import * as React from 'react';
import styled from '@emotion/styled';
import { Font } from '../../fonts';
import { MediaIconWidget } from '../content/MediaIconWidget';
import { MetaItemWidget, MetaItemWidgetProps } from './MetaItemWidget';
import { ImageModel } from '../../core/models/ImageModel';

export interface ResourcePageHeaderWidgetProps {
  label: string;
  meta: (MetaItemWidgetProps & { key: string })[];
  primaryAction?: React.JSX.Element;
  hero_image?: ImageModel;
  primary_image?: ImageModel;
}

export const ResourcePageHeaderWidget: React.FC<ResourcePageHeaderWidgetProps> = (props) => {
  const { primaryAction, meta, primary_image, hero_image, label } = props;
  return (
    <S.Header image={hero_image}>
      <S.HeaderInner>
        <S.HeaderContent>
          <S.ProfileIconRow>
            <S.HeaderProfileIcon
              font_size={40}
              lightBox={true}
              media={{
                image: primary_image,
                name: label
              }}
            />
            {primaryAction}
          </S.ProfileIconRow>
          <S.HeaderUsername>
            <S.At>@</S.At>
            {label}
          </S.HeaderUsername>
          <S.MetaBar>
            {meta
              .filter((m) => !!m)
              .map((m) => {
                return <MetaItemWidget {...m} key={m.key} />;
              })}
          </S.MetaBar>
        </S.HeaderContent>
      </S.HeaderInner>
    </S.Header>
  );
};
namespace S {
  const PADDING = 20;

  export const Header = styled.div<{ image?: ImageModel }>`
    height: 400px;
    background-position: center center;
    background-size: cover;
    background-image: url(${(p) => p.image?.url || ''});
    background-color: ${(p) => p.theme.button_primary.background};
    position: relative;
  `;

  export const HeaderInner = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      180deg,
      ${(p) => p.theme.layout.background_transparent},
      ${(p) => p.theme.layout.background}
    );
    display: flex;
    align-items: flex-end;
  `;

  export const ProfileIconRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    column-gap: 5px;
  `;

  export const HeaderProfileIcon = styled(MediaIconWidget)`
    border-radius: 5px;
    box-shadow: 0 0 20px black;
    width: 150px;
    aspect-ratio: 1/1;
  `;

  export const HeaderUsername = styled.div`
    font-size: 25px;
    font-family: ${Font.Special};
    color: ${(p) => p.theme.text.primary};
  `;

  export const At = styled.span`
    opacity: 0.5;
  `;

  export const HeaderContent = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    padding: ${PADDING}px;
  `;

  export const MetaBar = styled.div`
    display: flex;
    flex-direction: row;
    column-gap: 10px;
    flex-wrap: wrap;
    row-gap: 5px;
  `;
}
